export default {
    en: {
        sDate: "Start Date",
        eDate: "End Date",
        apply: "Apply",
        week: "Week",
        month: "Month",
        year: "Year",
        totalSale: "Total Sale",
        totalExpense: "Total Expenses",
        totalProfit: "Total Profit",
        remainingProducts: "Remaining Products",
        newWorth: "Net Worth",
        profitVsExpenses: "Profit vs Expenses",
        sale: "Sale",
        sold: "Products sold /monthly",
    },
    uz: {
        sDate: "Boshlang'ich Sana",
        eDate: "Tugash Sanasi",
        apply: "Saralash",
        week: "Haftalik",
        month: "Oylik",
        year: "Yillik",
        totalSale: "Umumiy Savdo",
        totalExpense: "Jami Xarajatlar",
        totalProfit: "Umumiy Foyda",
        remainingProducts: "Qoldiq Mahsulotlar",
        newWorth: "Kutilyotgan Daromad",
        profitVsExpenses: "Foyda va Xarajatlar",
        sale: "Savdo",
        sold: "Oylik savdo soni",
    },
    ru: {
        sDate: "Дата начала",
        eDate: "Дата окончания",
        apply: "Применять",
        week: "Неделю",
        month: "Месяц",
        year: "Год",
        totalSale: "Общая продажа",
        totalExpense: "Общий Расходы",
        totalProfit: "Общий прибыль",
        remainingProducts: "Остальные продукты",
        newWorth: "Ожидаемая стоимость",
        profitVsExpenses: "Прибыль и расходы",
        sale: "Продажа",
        sold: "Продукты продаются / ежемесячно",
    },
}